
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import Cta from '@/partials/Cta';
import Resources from './_resources.mdx';
import Checklist from './_checklist.mdx';
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "Here is the toolkit to develop your Creative Marketplace Platform, and Apps",
  "date": "2021-05-30"
};
const slug = 'creative-marketplace-app';
const tableOfContents = [{
  "title": "Creative Marketplace",
  "slug": "creative-marketplace",
  "children": []
}, {
  "title": "How to configure?",
  "slug": "how-to-configure",
  "children": []
}, {
  "title": "How Tradly Hosted Marketplace works?",
  "slug": "how-tradly-hosted-marketplace-works",
  "children": [{
    "title": "Listing Categories",
    "slug": "listing-categories",
    "children": []
  }, {
    "title": "Listing Attributes",
    "slug": "listing-attributes",
    "children": []
  }]
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <p>{`Looking to build a creative marketplace and apps? Here is the toolkit to launch any marketplace without writing a single line of code.`}</p>
    <p>{`Tradly Platform has a simple user interface to build any marketplace like `}<strong parentName="p">{`creative marketplace`}</strong>{` and can be controlled every feature from your end, in the dashboard. It is a complete white label solution.`}</p>
    <p>{`The marketplace can be built on any platform, whether it is Android or iOS. Along with this option, you also get a web app template to get started.`}</p>
    <p>{`Here is an example of how you can configure the catalog, listing fields in your marketplace`}</p>
    <_Heading level={2} id={"creative-marketplace"} nextElement={{
      "type": "jsx"
    }}>Creative Marketplace</_Heading>
    <img class="w-92 h-82 object-cover rounded-lg shadow-lg" src={require('../img/tradly/Creative_Marketplace.jpg').default} alt="Creative Marketplace" width="700" />
    <_Heading level={2} id={"how-to-configure"} nextElement={{
      "type": "paragraph"
    }}>How to configure?</_Heading>
    <p>{`Most of the marketplace template in Tradly allows you to activate digital product options. `}</p>
    <p>{`Go to SuperAdmin > Listings Features Activation > Enable Digital Products. `}</p>
    <_Heading level={2} id={"how-tradly-hosted-marketplace-works"} nextElement={{
      "type": "jsx"
    }}>How Tradly Hosted Marketplace works?</_Heading>
  <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/digital-product-marketplace.jpg" />
      </div>
    <p><a parentName="p" {...{
        "href": "https://dribbble.com/shots/13920101-Flowio"
      }}>{`https://dribbble.com/shots/13920101-Flowio`}</a></p>
    <p>{`Involving children in creative art is the way of helping them to develop fast and in a healthier way. They learn different types of skills in art.`}</p>
    <p>{`Learning has to be fun! Our E-Learning program for kids integrates gaming and learning to make our course more effective.`}</p>
    <_Heading level={3} id={"listing-categories"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Listing Categories</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Visual Art`}</li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Drawing`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Painting`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Sculpture`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Crafts`}</li>
        </ul>
      </li>
    </ul>
    <p>{`Dance `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Tap Dance  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Folk Dance  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Modern Dance `}</li>
        </ul>
      </li>
    </ul>
    <p>{`Music`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Classical Music  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Folk Music  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Soul Music  `}</li>
        </ul>
      </li>
    </ul>
    <p>{`Theatre`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Physical Theatre  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Epic Theatre  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Comedy  `}</li>
        </ul>
      </li>
      <li parentName="ul">
        <ul parentName="li" {...{
          "role": "list"
        }}>
          <li parentName="ul">{`Melodrama  `}</li>
        </ul>
      </li>
    </ul>
    <_Heading level={3} id={"listing-attributes"} nextElement={{
      "type": "paragraph"
    }}>Listing Attributes</_Heading>
    <p>{`General Attributes`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Classes Type  (Live)`}</li>
      <li parentName="ul">{`Difficulty (Beginner Friendly)`}</li>
    </ul>
    <Checklist mdxType="Checklist" />
    <Resources mdxType="Resources" /> 
    <Cta mdxType="Cta" />



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
